import React from "react";
import styled, { keyframes } from "styled-components";
import { toast } from "react-toastify";
import LineBtn from "../../../Button/LineBtn";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { YoutubeGeneratedLink } from "./youtubeLinkApi";

export type YoutubeLinkState = { email: string } & (
  | { status: "loading" }
  | { status: "success"; result: YoutubeGeneratedLink }
  | { status: "error"; message: string }
);

export default function YoutubeLinkModal({
  state,
  closeEvent,
}: {
  state: YoutubeLinkState;
  closeEvent: () => void;
}) {
  const loading = state.status === "loading";
  return (
    <DefaultModalLayout
      modalTitle="회차 링크 생성"
      isMediumModal
      confirmBtnText="닫기"
      confirmDisabled={loading}
      confirmEvent={closeEvent}
      closeEvent={closeEvent}
      cancelBtn={<></>}
      leftBottomBtn={<></>}
      contentPadding="24px 32px"
    >
      <Content aria-live="polite" aria-busy={loading}>
        <div>{state.email}</div>
        {state.status === "loading" ? (
          <>
            <p>링크를 생성하고 있습니다. 최대 2분 정도 걸릴 수 있습니다.</p>
            <LoadingBar role="progressbar" aria-label="회차 링크 생성 중" />
          </>
        ) : state.status === "error" ? (
          <p role="alert">{state.message}</p>
        ) : (
          <>
            <LinkAddress href={state.result.link} target="_blank" rel="noopener noreferrer">
              {state.result.link}
            </LinkAddress>
            {state.result.expire && <div>만료일: {state.result.expire}</div>}
            <LineBtn
              type="button"
              btnText="복사하기"
              icon="content_copy"
              btnClickEvent={async () => {
                try {
                  await navigator.clipboard.writeText(state.result.link);
                  toast.success("회차링크가 복사되었습니다.");
                } catch {
                  toast.error("회차링크 복사에 실패했습니다.");
                }
              }}
            />
          </>
        )}
      </Content>
    </DefaultModalLayout>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  line-height: 1.5;
  overflow-wrap: anywhere;
`;

const LinkAddress = styled.a`
  color: #1976d2;
  text-decoration: underline;
`;

const slide = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(300%); }
`;

const LoadingBar = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: #e8edf2;
  overflow: hidden;
  &::after {
    content: "";
    display: block;
    width: 40%;
    height: 100%;
    background: #1976d2;
    animation: ${slide} 1.4s linear infinite;
  }
  @media (prefers-reduced-motion: reduce) {
    &::after { animation: none; }
  }
`;
